import type { ScopeNode } from "../scope-tree";
import { globalActionIds, type GlobalActionId } from "./action-ids";

/**
 * Global root scope - available at the root level of command palette.
 * Contains search/navigation actions for different entity types.
 */
export const globalRootScope: ScopeNode<GlobalActionId, "globalRoot"> = {
  id: "globalRoot",
  label: "Search",
  actionRefs: [
    { actionId: globalActionIds.searchOrders },
    { actionId: globalActionIds.searchReturns },
    { actionId: globalActionIds.searchCustomers },
    { actionId: globalActionIds.searchConversations },
    { actionId: globalActionIds.searchPages },
    { actionId: globalActionIds.searchHelpArticles },
  ],
};
